import { Box, Chip, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Cancel';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import XCheckBoxInput from '../../../../../../components/inputs/XCheckBoxInput';

export type TemplateTableRowProps = {
  key: string;
  title: string;
  dataType: string;
  isVerifiable: boolean;
  verificationExplanation: string;
  captureFieldName: string;
  verifyFieldName: string;
  requiredFieldName: string;
  onCheckboxChange?: (fieldName: string, isChecked: boolean) => void;
};

const TemplateTableRow = ({
  title,
  dataType,
  isVerifiable,
  verificationExplanation,
  captureFieldName,
  verifyFieldName,
  requiredFieldName,
  onCheckboxChange
}: TemplateTableRowProps) => {

  return (
      <TableRow>
        <TableCell>
          <Typography variant="h6">{title}</Typography>
        </TableCell>
        <TableCell>
          <Typography variant="h6">{dataType}</Typography>
        </TableCell>
        <TableCell>
          <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
          >
            <Chip
                icon={isVerifiable ? <CheckIcon color="success"/> : <CloseIcon color="error"/>}
                variant="filled"
                size="small"
                label={isVerifiable ? 'YES' : 'NO'}
                sx={{ mr: 1 }}
            />
            <Tooltip
                title={verificationExplanation}
                arrow
            >
              <InfoIcon
                  color="info"
                  fontSize="small"
              />
            </Tooltip>
          </Box>
        </TableCell>

        <TableCell>
          <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
          >
            <XCheckBoxInput
                label=""
                name={captureFieldName}
            />
            <Tooltip
                title="When enabled, this document/biometric will be collected from the customer during onboarding."
                arrow
            >
              <InfoIcon
                  color="info"
                  fontSize="small"
              />
            </Tooltip>
          </Box>
        </TableCell>

        <TableCell>
          <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
          >
            <XCheckBoxInput
                label=""
                name={verifyFieldName}
                disabled={!isVerifiable}
                onChange={(e) => onCheckboxChange(verifyFieldName, e.target.checked)}
            />
            <Tooltip
                title="When enabled, the captured data will be validated against the ID issuer's records."
                arrow
            >
              <InfoIcon
                  color="info"
                  fontSize="small"
              />
            </Tooltip>
          </Box>
        </TableCell>

        <TableCell>
          <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
          >
            <XCheckBoxInput
                label=""
                name={requiredFieldName}
            />
            <Tooltip
                title="When enabled, the customer cannot complete onboarding without providing this item."
                arrow
            >
              <InfoIcon
                  color="info"
                  fontSize="small"
              />
            </Tooltip>
          </Box>
        </TableCell>
      </TableRow>
  );
};

export default TemplateTableRow;